import { Outlet } from "react-router-dom";
import AppContext from "./context.js";

import { useContext } from "react";
import "../App.css";
function AppLayout() {
  const { organizationData, organizationIsloading } = useContext(AppContext);
  return (
    <div>
      <div className="header">
        {!organizationIsloading ? (
          <img
            className="logo"
            src={`https://binesh-motahar.liara.run/assets/${organizationData.data.logo}`}
            alt="logo"
          ></img>
        ) : (
          ""
        )}
      </div>

      <Outlet className="introduction" />
      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <p className="text s-400" style={{ color: "var(--gray-700)" }}>
        بینش مطهر سپاهان شهر
      </p>
    </footer>
  );
}

export default AppLayout;
